import BaseFormItem from "../BaseFormItem";
import React from "react";
import Control from "lib/common/descriptorcontrols/StringField/dropdown";

export class StringFielddropdown extends BaseFormItem {
    render() {
        const {activeRecord, descriptor} = this.props;
        return <Control {...this.getPlumbingProps()}
                        value={activeRecord.get(descriptor.key)}
                        enabled={activeRecord.isFieldEnabled(descriptor.key)} />;
    }
}

export default StringFielddropdown;



// WEBPACK FOOTER //
// ./app/lib/dataentry/lib/dataentryform/formitems/StringField/dropdown.js